import AuthContentWrapper from "./components/AuthContentWrapper";
import { Column, SizedBox } from "../../common/components/CommonBaseComponents";
import { C2Text, T1Text } from "../../common/components/text/CustomText";
import { Theme } from "../../common/Theme";
import FullWidthButton from "../../common/components/button/FullWidthButton";
import CustomImage from "../../common/components/image/CustomImage";
import LocalStorageKey from "../../common/enums/LocalStorageKey";
import LMPAuthUtils from "../../api/lmp/LMPAuthUtils";

function MoveAppPage() {
    function handleCancel() {
        const serverCountry = localStorage.getItem(LocalStorageKey.server) || "TH";
        window.location.href = LMPAuthUtils.getLoginUrl({ serverCountry });
    }

    return (
        <AuthContentWrapper contentPadding={"62px 60px"}>
            <Column justifyContent={"center"}>
                <T1Text letterSpacing={"-0.56px"} fontWeight={"500"}>
                    Move to the Manager App!
                </T1Text>
                <SizedBox height={"20px"} />
                <C2Text fontColor={Theme.color.gray500} textAlign={"center"}>
                    Scan the QR code to continue managing your store in the Laundry Crew Manager app.
                </C2Text>
                <SizedBox height={"32px"} />
                <CustomImage imageName={"image_dummy_qr_code"} width={"240px"} height={"240px"} />
                <SizedBox height={"32px"} />
                <FullWidthButton
                    onClick={handleCancel}
                    text={"Cancel"}
                    backgroundColor={Theme.color.white}
                    border={`1px solid ${Theme.color.gray250}`}
                />
            </Column>
        </AuthContentWrapper>
    );
}

export default MoveAppPage;
